/**
 * Configuración económica centralizada — Movex.
 * Todo lo frecuente debe ser barato; todo lo caro debe ser raro.
 * Mantener sincronizado: functions/common/economyConfig.js, web-app/src/config/economyConfig.js
 */
export const ENABLE_GOOGLE_ROUTES = false;
export const ENABLE_DISTANCE_MATRIX = false;
export const ENABLE_COMPUTE_ROUTE_MATRIX = false;
export const ENABLE_DEBUG_LOGS = false;

export const MAX_ROUTE_CALLS_PER_SESSION = 3;
export const MAX_NEARBY_DRIVERS = 10;
export const MAX_INITIAL_DISPATCH_DRIVERS = 10;
export const DISPATCH_WAVE_SIZE = 3;
/** Segundos sin respuesta del socio antes de llamar al siguiente más cercano. */
export const DISPATCH_WAVE_TIMEOUT_SEC = 30;
/** Radio recomendado en panel admin (km) para grúas en zona urbana. */
export const RECOMMENDED_DRIVER_RADIUS_KM = 25;

export const MAX_FIRESTORE_LIST_LIMIT = 20;
export const MAX_BOOKING_HISTORY_LIMIT = 30;
/** Historial de reservas del conductor para ingresos (limitToLast RTDB). */
export const MAX_DRIVER_BOOKING_HISTORY_LIMIT = 120;
/** Reservas recientes que carga el panel admin (RTDB limitToLast). */
export const ADMIN_BOOKING_FETCH_LIMIT = 300;
/** Usuarios por página en listados admin (RTDB limitToFirst). */
export const ADMIN_USERS_PAGE_SIZE = 50;

export const LOCATION_UPDATE_MIN_DISTANCE_IDLE_METERS = 80;
export const LOCATION_UPDATE_MIN_DISTANCE_SEARCHING_METERS = 50;
/** Viaje activo: más frecuente para mapa fluido (solo RTDB, sin Google Routes). */
export const LOCATION_UPDATE_MIN_DISTANCE_ACTIVE_METERS = 12;
/** Alias legacy */
export const LOCATION_UPDATE_MIN_DISTANCE_METERS = LOCATION_UPDATE_MIN_DISTANCE_ACTIVE_METERS;

export const LOCATION_UPDATE_INTERVAL_IDLE_MS = 60000;
export const LOCATION_UPDATE_INTERVAL_SEARCHING_MS = 30000;
export const LOCATION_UPDATE_INTERVAL_ACTIVE_MS = 6000;

/** Interpolación local entre pings GPS (cliente). */
export const LOCATION_SMOOTH_TICK_MS = 100;
export const LOCATION_SMOOTH_ANIMATION_MS = 5500;

export const LOCATION_FRESH_MAX_AGE_MS = 45000;
export const DRIVER_LOCATION_MAX_AGE_MS = 120000;
/** Ubicación aceptada al despachar reserva (socios idle actualizan GPS con menos frecuencia). */
export const DISPATCH_LOCATION_MAX_AGE_MS = 180000;
export const ROUTE_RECALC_DEVIATION_METERS = 300;

/** Búsqueda progresiva: 5 → 10 → 15 → 25 km (ajustable con driverRadius del admin). */
export const NEARBY_RADIUS_STEPS_KM = [5, 10, 15, 25];
export const NEARBY_RADIUS_MAX_KM = 25;

export const PLACES_MIN_CHARS = 3;
export const PLACES_DEBOUNCE_MS = 800;
export const GEOCODING_DEBOUNCE_MS = 1000;
export const REVERSE_GEOCODING_DEBOUNCE_MS = 1000;

export const CACHE_TTL_PLACES_MINUTES = 30;
export const CACHE_TTL_GEOCODING_MINUTES = 60;
export const CACHE_TTL_ROUTES_MINUTES = 15;
export const CACHE_TTL_SETTINGS_MINUTES = 60;
export const CACHE_TTL_SERVICE_TYPES_HOURS = 6;

export const CACHE_TTL_PLACES_MS = CACHE_TTL_PLACES_MINUTES * 60 * 1000;
export const CACHE_TTL_GEOCODING_MS = CACHE_TTL_GEOCODING_MINUTES * 60 * 1000;
export const CACHE_TTL_ROUTES_MS = CACHE_TTL_ROUTES_MINUTES * 60 * 1000;
/** Alias legacy */
export const CACHE_TTL_MINUTES = CACHE_TTL_ROUTES_MINUTES;
export const CACHE_TTL_MS = CACHE_TTL_ROUTES_MS;

export const MAX_IMAGE_UPLOAD_MB = 2;
export const MAX_PROFILE_IMAGE_KB = 500;
export const MAX_EVIDENCE_IMAGE_MB = 1;

export default {
    ENABLE_GOOGLE_ROUTES,
    ENABLE_DISTANCE_MATRIX,
    ENABLE_COMPUTE_ROUTE_MATRIX,
    ENABLE_DEBUG_LOGS,
    MAX_ROUTE_CALLS_PER_SESSION,
    MAX_NEARBY_DRIVERS,
    MAX_INITIAL_DISPATCH_DRIVERS,
    DISPATCH_WAVE_SIZE,
    DISPATCH_WAVE_TIMEOUT_SEC,
    RECOMMENDED_DRIVER_RADIUS_KM,
    MAX_FIRESTORE_LIST_LIMIT,
    MAX_BOOKING_HISTORY_LIMIT,
    MAX_DRIVER_BOOKING_HISTORY_LIMIT,
    ADMIN_BOOKING_FETCH_LIMIT,
    ADMIN_USERS_PAGE_SIZE,
    LOCATION_UPDATE_MIN_DISTANCE_IDLE_METERS,
    LOCATION_UPDATE_MIN_DISTANCE_SEARCHING_METERS,
    LOCATION_UPDATE_MIN_DISTANCE_ACTIVE_METERS,
    LOCATION_UPDATE_MIN_DISTANCE_METERS,
    LOCATION_UPDATE_INTERVAL_IDLE_MS,
    LOCATION_UPDATE_INTERVAL_SEARCHING_MS,
    LOCATION_UPDATE_INTERVAL_ACTIVE_MS,
    LOCATION_SMOOTH_TICK_MS,
    LOCATION_SMOOTH_ANIMATION_MS,
    LOCATION_FRESH_MAX_AGE_MS,
    DRIVER_LOCATION_MAX_AGE_MS,
    DISPATCH_LOCATION_MAX_AGE_MS,
    ROUTE_RECALC_DEVIATION_METERS,
    NEARBY_RADIUS_STEPS_KM,
    NEARBY_RADIUS_MAX_KM,
    PLACES_MIN_CHARS,
    PLACES_DEBOUNCE_MS,
    GEOCODING_DEBOUNCE_MS,
    REVERSE_GEOCODING_DEBOUNCE_MS,
    CACHE_TTL_PLACES_MS,
    CACHE_TTL_GEOCODING_MS,
    CACHE_TTL_ROUTES_MS,
    CACHE_TTL_MINUTES,
    CACHE_TTL_MS,
    MAX_IMAGE_UPLOAD_MB,
    MAX_PROFILE_IMAGE_KB,
    MAX_EVIDENCE_IMAGE_MB,
};
